<template>
  <div class="case">
    <!-- 视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">{{ business.name }}</h1>
        <p class="animate__animated animate__fadeInUp">BUSINESS DETAILS</p>
      </div>
    </div>

    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <!-- 业务概览部分 -->
        <div class="business-overview">
          <div class="overview-grid">
            <div class="overview-image">
              <img :src="business.filePath" :alt="business.name">
              <div class="image-overlay">
                <div class="overlay-content">
                  <h3>{{ business.name }}</h3>
                  <p>专业服务，品质保证</p>
                </div>
              </div>
            </div>
            <div class="overview-details">
              <h2>{{ business.name }}</h2>
              <div class="tags-container">
                <el-tag 
                  v-for="(item, index) in tagList" 
                  :key="index"
                  effect="plain"
                  class="tag-item">
                  {{ item }}
                </el-tag>
              </div>
              <div class="action-buttons">
                <el-button 
                  type="primary" 
                  class="contact-btn"
                  @click="contactNow">
                  <i class="el-icon-phone-outline"></i>
                  免费回电
                </el-button>
                <el-button 
                  type="success" 
                  class="contact-btn"
                  @click="showCompanyInfo">
                  <i class="el-icon-message"></i>
                  立即联系
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 业务介绍部分 -->
        <div class="business-details">
          <div class="section-header">
            <h3>业务介绍</h3>
            <div class="header-line"></div>
          </div>
          <div class="details-content" v-html="business.description"></div>
        </div>
      </div>
    </div>
    <ContactUs ref="contactUs"></ContactUs>
    <CompanyInfo ref="companyInfo"></CompanyInfo>
  </div>
</template>

<style lang="scss" scoped>
.case {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 40vh;
    background: url('../assets/img/bgtop.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;
      padding: 0 20px;

      h1 {
        font-size: 2.8rem;
        margin-bottom: 1rem;
        font-weight: 600;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 1.2rem;
        letter-spacing: 0.2rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .case-section {
    margin-top: -60px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    &-content {
      max-width: 1200px;
      margin: 0 auto;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      overflow: hidden;
    }
  }

  // 业务概览部分
  .business-overview {
    padding: 40px;

    .overview-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      align-items: center;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }

    .overview-image {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
      background: white;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 400px;
        object-fit: contain;
        transition: transform 0.6s ease;
      }

      .image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to top, rgba(64, 158, 255, 0.9), rgba(64, 158, 255, 0.7));
        opacity: 0;
        transition: opacity 0.4s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px;
        color: white;

        .overlay-content {
          text-align: center;
          transform: translateY(20px);
          transition: transform 0.4s ease;

          h3 {
            font-size: 1.5rem;
            margin-bottom: 15px;
            font-weight: 500;
          }

          p {
            font-size: 1rem;
            opacity: 0.9;
          }
        }
      }

      &:hover {
        img {
          transform: scale(1.05);
        }

        .image-overlay {
          opacity: 1;

          .overlay-content {
            transform: translateY(0);
          }
        }
      }
    }

    .overview-details {
      h2 {
        font-size: 2rem;
        color: #2c3e50;
        margin-bottom: 30px;
        font-weight: 600;
        text-align: center;
      }

      .tags-container {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 40px;
        justify-content: center;
        align-items: center;

        .tag-item {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 8px 20px;
          font-size: 0.95rem;
          border-radius: 25px;
          background: #f0f7ff;
          border: 1px solid #409EFF;
          color: #409EFF;
          transition: all 0.3s ease;
          font-weight: 500;
          height: 36px;

          &:hover {
            background: #409EFF;
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 20px;
        justify-content: center;

        .contact-btn {
          padding: 12px 30px;
          font-size: 1rem;
          border-radius: 25px;
          transition: all 0.3s ease;
          min-width: 160px;

          i {
            margin-right: 8px;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }

  // 业务介绍部分
  .business-details {
    padding: 40px;
    background: #f8f9fa;

    .section-header {
      text-align: center;
      margin-bottom: 30px;
      position: relative;

      h3 {
        font-size: 1.8rem;
        color: #2c3e50;
        margin-bottom: 15px;
        font-weight: 600;
      }

      .header-line {
        width: 60px;
        height: 3px;
        background: #409EFF;
        margin: 0 auto;
      }
    }

    .details-content {
      background: white;
      padding: 30px;
      border-radius: 12px;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
      line-height: 1.8;
      color: #495057;
      white-space:pre-wrap;

      :deep(p) {
        margin-bottom: 15px;
        white-space: pre-wrap;
      }

      :deep(h1, h2, h3, h4, h5, h6) {
        color: #2c3e50;
        margin: 20px 0 10px;
      }

      :deep(ul, ol) {
        padding-left: 20px;
        margin-bottom: 15px;
      }

      :deep(img) {
        max-width: 100%;
        height: auto;
        border-radius: 8px;
        margin: 15px 0;
      }

      :deep(.ql-size-small) {
        font-size: 0.85em;
      }
      
      :deep(.ql-size-large) {
        font-size: 1.25em;
      }
      
      :deep(.ql-size-huge) {
        font-size: 1.5em;
      }

      :deep(.ql-align-center) {
        text-align: center !important;
        display: block;
        width: 100%;
        margin: 0 auto;
        white-space: normal;
      }

      :deep(.ql-align-right) {
        text-align: right !important;
        display: block;
        width: 100%;
        margin: 0 auto;
        white-space: normal;
      }

      :deep(.ql-align-center span) {
        display: inline;
        white-space: normal;
      }

      :deep(.ql-align-center strong) {
        display: inline;
        white-space: normal;
      }

      :deep(pre) {
        white-space: pre-wrap;
      }
    }
  }
}

@media (max-width: 1200px) {
  .parallax-banner {
    height: 25vh!important;
  }
}
// 响应式设计
@media (max-width: 768px) {
  .case {
    .parallax-banner {
      .banner-content {
        h1 {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        p {
          font-size: 0.8rem;
          letter-spacing: 0.1rem;
        }
      }
    }

    .case-section {
      margin-top: -15px;
      padding: 0 15px;
    }

    .business-overview {
      padding: 20px;

      .overview-image {
        img {
          height: 300px;
        }
      }

      .overview-details {
        h2 {
          font-size: 1.5rem;
        }

        .action-buttons {
          flex-direction: column;

          .contact-btn {
            width: 100%;
          }
        }
      }
    }

    .business-details {
      padding: 20px;

      .section-header {
        h3 {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>

<script>
import Banner from "../components/Banner";
import ContactUs from "../components/ContactUs.vue";
import CompanyInfo from "../components/CompanyInfo.vue";

export default {
  components: {
    Banner,
    ContactUs,
    CompanyInfo
  },
  data() {
    return {
      loading: true,
      id: 0,
      caseList: [],
      business: {},
      tagList: [],
      contactForm: {
        name: "",
        phone: ""
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.loadBusinessData();
    this.loadCaseData();
  },
  methods: {
    loadBusinessData() {
      this.$http
        .get(`business/get?id=${this.id}`)
        .then(response => {
          this.business = response.data.data;
          this.business.filePath = this.imgserver + this.business.filePath;
          this.tagList = this.business.remark.split(",");
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadCaseData() {
      this.$http
        .get(`case/getCases?id=${this.id}`)
        .then(response => {
          this.caseList = response.data.data;
          for (let obj of this.caseList) {
            obj.fileUrls = this.imgserver + obj.fileUrls.split(",")[0];
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    contactNow() {
      this.$refs.contactUs.showDialogVisible();
    },
    showCompanyInfo() {
      this.$refs.companyInfo.showDialog();
    }
  }
};
</script>